var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaymentMethodFail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.81818 19.0001H18.5858L21.2929 21.7072L22.7071 20.293L2.70711 0.292969L1.29289 1.70718L2.60003 3.01432C1.69873 3.13287 1 3.97671 1 5.00008V17.0001C1 18.1046 1.81403 19.0001 2.81818 19.0001ZM3 5.00008H4.58579L7.58579 8.00008H3V5.00008ZM9.58579 10.0001H3V17.0001H16.5858L9.58579 10.0001ZM8.21421 3.00008L10.2142 5.00008H21V8.00008H13.2142L15.2142 10.0001H21V15.7859L22.8927 17.6786C22.9621 17.4667 23 17.2383 23 17.0001V5.00008C23 3.89551 22.186 3.00008 21.1818 3.00008H8.21421Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentMethodFail);
export default __webpack_public_path__ + "static/media/payment-method-fail.4fe3af36d1924186130a8f68ff7178cd.svg";
export { ForwardRef as ReactComponent };